/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedPersonalizedFilterToast_shippingFilters$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespComponents_shippingFilters$ref: FragmentReference;
export type SbRespComponents_shippingFilters = $ReadOnlyArray<{|
  +$fragmentRefs: SbSharedPersonalizedFilterToast_shippingFilters$ref,
  +$refType: SbRespComponents_shippingFilters$ref,
|}>;
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespComponents_shippingFilters",
  "type": "ShippingFilterType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedPersonalizedFilterToast_shippingFilters",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'efe06964b9b07555da0ee972e23cecaa';
module.exports = node;
